import ButtonDeconnect from "../../components/Button Deconnect/ButtonDeconnect";
import React, {useEffect, useState} from "react";
import Cookies from "js-cookie";
import {Link, useNavigate} from "react-router-dom";
import verifyRoleInJWTtoken from "../../services/VerifyRoleInJWTtoken";
import IsAdmin from "../../components/Admin/IsAdmin";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen, faTags, faCartShopping, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import "./AdminModern.scss";

function Admin() {
    const [seeAllOrders, setSeeAllOrders] = useState(false);
    const [addPromoCode, setAddPromoCode] = useState(false);
    const [addProduct, setAddProduct] = useState(false);
    const [seeAllProducts, setSeeAllProducts] = useState(false);
    const [isAdmin, setIsAdmin] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (isAdmin === null) {
            return;
        }
        !isAdmin && navigate("/");
    }, [isAdmin]);

    useEffect(() => {
        if (seeAllOrders) {
            navigate("/admin/orders");
        }
        setSeeAllOrders(false);
    }, [seeAllOrders]);

    useEffect(() => {
        if (addPromoCode) {
            navigate("/admin/promo-code");
        }
        setAddPromoCode(false);
    }, [addPromoCode]);

    useEffect(() => {
        if (addProduct) {
            navigate("/admin/add-product");
        }
        setAddProduct(false);
    }, [addProduct]);

    useEffect(() => {
        if (seeAllProducts) {
            navigate("/admin/products");
        }
        setSeeAllProducts(false);
    }, [seeAllProducts]);

    return (
        <div className="admin-modern-container">
            <IsAdmin setAdmin={setIsAdmin}/>
            {isAdmin ? (
                <>
                    <div className="admin-header">
                        <h2>Tableau de Bord Administrateur</h2>
                        <p>Bienvenue dans votre espace de gestion centralisé</p>
                    </div>

                    <div className="admin-grid-2">
                        <div className="admin-card" style={{ cursor: "pointer" }} onClick={() => setSeeAllOrders(true)}>
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem", color: "var(--admin-primary)" }}>
                                <FontAwesomeIcon icon={faCartShopping} size="2x" style={{ marginRight: "1rem" }} />
                                <h3 style={{ margin: 0 }}>Commandes</h3>
                            </div>
                            <p style={{ color: "var(--admin-text-muted)", margin: 0 }}>Consultez, expédiez et gérez toutes les commandes passées sur la boutique.</p>
                        </div>
                        
                        <div className="admin-card" style={{ cursor: "pointer" }} onClick={() => setSeeAllProducts(true)}>
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem", color: "var(--admin-primary)" }}>
                                <FontAwesomeIcon icon={faBoxOpen} size="2x" style={{ marginRight: "1rem" }} />
                                <h3 style={{ margin: 0 }}>Catalogue Produits</h3>
                            </div>
                            <p style={{ color: "var(--admin-text-muted)", margin: 0 }}>Visualisez et modifiez l'ensemble de votre inventaire de produits existants.</p>
                        </div>
                        
                        <div className="admin-card" style={{ cursor: "pointer" }} onClick={() => setAddProduct(true)}>
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem", color: "var(--admin-success)" }}>
                                <FontAwesomeIcon icon={faPlusCircle} size="2x" style={{ marginRight: "1rem" }} />
                                <h3 style={{ margin: 0 }}>Nouveau Produit</h3>
                            </div>
                            <p style={{ color: "var(--admin-text-muted)", margin: 0 }}>Ajoutez rapidement un nouvel article à votre boutique avec des photos et un prix.</p>
                        </div>
                        
                        <div className="admin-card" style={{ cursor: "pointer" }} onClick={() => setAddPromoCode(true)}>
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem", color: "var(--admin-secondary)" }}>
                                <FontAwesomeIcon icon={faTags} size="2x" style={{ marginRight: "1rem" }} />
                                <h3 style={{ margin: 0 }}>Codes Promo</h3>
                            </div>
                            <p style={{ color: "var(--admin-text-muted)", margin: 0 }}>Créez et gérez vos réductions et offres promotionnelles pour vos clients.</p>
                        </div>
                    </div>
                    
                    <div style={{ marginTop: "3rem", display: "flex", justifyContent: "center" }}>
                        <ButtonDeconnect />
                    </div>
                </>
            ) : null}
        </div>
    );
}

export default Admin;